import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

import { AnalyticsService } from './main/gtm/analytics.service';
import { LocalStorage } from './main/client/helpers/local-storage';
import { MainRoutes } from './main/main-routes.enum';

import { environment } from '../environments/environment';

@Component({
    selector: 'thr-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    private isClientPortal = environment.portalClient;

    constructor(
        private analyticsService: AnalyticsService,
        private localStorage: LocalStorage,
        private router: Router,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.setLang();
        this.setViewPage();
        this.checkStep();
    }

    private setLang() {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    private setViewPage() {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.analyticsService.pageView();
        });
    }

    private checkStep() {
        const step = this.localStorage.step;

        switch (step) {
            case 1:
                this.router.navigateByUrl(`${MainRoutes.TEST}${document.location.search}`);
                break;
            case 2:
                this.router.navigateByUrl(`${MainRoutes.TEST}${document.location.search}`);
                break;
            case 3:
                this.router.navigateByUrl(`${MainRoutes.FULL_DATA}${document.location.search}`);
                break;
            case 3.1:
                this.router.navigateByUrl(`${MainRoutes.TEST_TRANSFER}${document.location.search}`);
                break;
            case 3.2:
                this.router.navigateByUrl(`${MainRoutes.TEST_RATE}${document.location.search}`);
                break;
            case 4:
            case 5:
                this.router.navigateByUrl(`${MainRoutes.FULL_DATA}${document.location.search}`);
                break;
            case 7:
                this.router.navigateByUrl(`${MainRoutes.NEW_CONTRACT_ADVICE}${document.location.search}`);
                break;
            case 8:
                this.router.navigateByUrl(`${MainRoutes.OPERATIVE}${document.location.search}`);
                break;
            case 6:
            case 10:
                this.router.navigateByUrl(`${MainRoutes.CONTRIBUTION}${document.location.search}`);
                break;
            case 11:
                this.router.navigateByUrl(`${MainRoutes.ASSIGNMENT}${document.location.search}`);
                break;
            case 12:
                this.router.navigateByUrl(`${MainRoutes.DISINVESTMENT}${document.location.search}`);
                break;
            //New ADV-3571
            case 13:
                this.router.navigateByUrl(`${MainRoutes.CONTRIBUTION}${document.location.search}`);
                break;
            case 99:
                break;
            default:
                if (this.localStorage.contractCode) {
                    this.localStorage.contractCode = undefined;
                }

                if (this.isClientPortal) {
                    this.router.navigateByUrl(`${MainRoutes.NEW_CONTRACT_INTRO}${document.location.search}`);
                } else {
                    this.router.navigateByUrl(`${MainRoutes.NEW_CONTRACT}${document.location.search}`);
                }
                break;
        }
        //Después de navegar, reseteo el step para que no interfiera en la carga otras partes de la aplicación (onboarding/new/intro ADV-7018)
        this.localStorage.step = undefined;
    }
}
